/** Numeric target text is stored as TEXT, unlike monthly DECIMAL(18,4) readings. */
export function isTargetFigure(value) {
    const text = value.trim();
    return text.length <= 255 && /^-?\d+(\.\d{1,4})?$/.test(text);
}
/** A scalar range target is a zero-width band; no unstated tolerance is invented. */
export function meetsNumericTarget(actual, target, inverse, targetRange = false) {
    return targetRange
        ? actual === target
        : inverse
            ? actual <= target
            : actual >= target;
}
/** Compare stored decimal text exactly, before any display-only Number conversion. */
export function meetsDecimalTarget(actual, target, inverse, targetRange = false) {
    const parse = (value) => {
        const text = value.trim();
        return text.length <= 255 ? /^(-?)(\d+)(?:\.(\d+))?$/.exec(text) : null;
    };
    const a = parse(actual);
    const t = parse(target);
    if (!a || !t)
        return null;
    const places = Math.max(a[3]?.length ?? 0, t[3]?.length ?? 0);
    const scaled = (parts) => {
        const magnitude = BigInt(parts[2] + (parts[3] ?? "").padEnd(places, "0"));
        return parts[1] === "-" ? -magnitude : magnitude;
    };
    return meetsNumericTarget(scaled(a), scaled(t), inverse, targetRange);
}
//# sourceMappingURL=target-figure.js.map